/* eslint-disable no-self-assign */
/* eslint-disable @typescript-eslint/camelcase, @typescript-eslint/no-use-before-define */
import ReactDOM from 'react-dom'
import React from 'react'
import Snackbar from '~/reactapp/shared/Snackbar'

/* eslint-disable */
/* global angular fetch */
/* global angular */
import intl from 'react-intl-universal'
import get from 'lodash/get'
import isBoolean from 'lodash/isBoolean'
import { hasPermission } from '../services/permission'
import CONSTANTS from '~/constants'
import { getLocks } from '~/api/story'
import { gql } from '@apollo/client'
import {
  SEARCH_TYPE,
  SEARCH_TYPE_PARAM,
  SEARCH_ID_PARAM,
  resolveSearchType,
  sanitizeStoredSearchType,
} from './utils'
import SelectTemplateModal from '~/reactapp/App/ModalContext/SelectTemplateModal'
import link from './link'
import {
  DELETED_FROM_NEW_EDITOR,
  STORY_DELETED_NAME,
  DEFAULT_SNACKBAR_TIMEOUT,
  EVIDENTLY_FLAG,
} from '~/util/constants/keys'

const determineSearchBarPlaceholder = (searchType) =>
  searchType === SEARCH_TYPE.TERM
    ? intl.get('search.template.termsPlaceholder')
    : intl.get('search.template.idPlaceholder')

export default [
  '$scope',
  '$rootScope',
  '$location',
  'searchService',
  'authorService',
  'searchFiltersService',
  '$timeout',
  '$interval',
  'padlockService',
  'storeService',
  'toastr',
  'siteService',
  '$http',
  'pharosService',
  'settingsService',
  'evidentlyService',
  Controller,
]

function Controller(
  $scope,
  $rootScope,
  $location,
  searchService,
  authorService,
  searchFiltersService,
  $timeout,
  $interval,
  padlockService,
  storeService,
  toastr,
  siteService,
  $http,
  pharosService,
  settingsService,
  evidentlyService
) {
  let timer
  let interval
  let currentIds
  let reactRenderContainer

  this.intl = intl
  $scope.companySettings = $scope.$resolve.initialSettingsLoad
  $scope.searchTypeIndex = SEARCH_TYPE.TERM
  $scope.searchBarPlaceholder = determineSearchBarPlaceholder(
    $scope.searchTypeIndex
  )
  $scope.searchStatus = null
  $scope.searchResults = []
  $scope.queryParams = []
  $scope.filterConfig = []
  $scope.authorService = authorService
  $scope.isIframe = !!window.frameElement
  $scope.searchTypes = [
    {
      label: intl.get('search.template.buttonTerm'),
      index: SEARCH_TYPE.TERM,
      testId: 'search-by-term-btn',
    },
    {
      label: intl.get('search.template.buttonId'),
      index: SEARCH_TYPE.ID,
      testId: 'search-by-id-btn',
    },
  ]

  // Intentionally bypassing isStatefulEnbaled code - COMP-4896
  const isStatefulEnabled = false
  this.shouldRerender = false
  this.createStoryButtonWrapper = null
  this.snackbarWrapper = null

  const LOCK_STATUS_CHANGED_SUBSCRIPTION = gql`
    subscription OnLockStatusChanged($documentIds: [String!]!) {
      lockStatusChanged(documentIds: $documentIds) {
        documentId
        locked
        attribute
      }
    }
  `

  let gqlClient

  if (isStatefulEnabled) {
    import(/* webpackChunkName: 'graphql-client' */ '~/graphql/client').then(
      ({ default: client }) => {
        gqlClient = client
      }
    )
  }

  // on staging there is no create button when search pulled through related items
  $scope.canCreateStory =
    hasPermission(window.userRolesAuth.story.createStory) && !$scope.isIframe

  $rootScope.requiresActions = false

  // INIT SEARCH CALL
  // Get Search filters and THEN search
  this.$onInit = () => {
    const localSettings = JSON.parse(
      window.localStorage.getItem('arc.searchFilterSettings')
    )
    $scope.searchTypeIndex = resolveSearchType(
      $location.search(),
      window.localStorage.getItem('searchTypeIndex')
    )

    $scope.searchBarPlaceholder = determineSearchBarPlaceholder(
      $scope.searchTypeIndex
    )
    searchFiltersService
      .getFilters($location.search(), $scope, localSettings)
      .then((filters) => {
        $scope.filterConfig = filters
        if (!get($scope, 'filterConfig.websites.value')) {
          toastr.error(intl.get('search.searchFiltersService.error'))
          return
        }

        if ($scope.searchTypeIndex === SEARCH_TYPE.ID) {
          const term = $location.search()
          $scope.filterConfig.searchBar.value = get(term, SEARCH_ID_PARAM, '')
        }

        $scope.runSearch()
      })
      .catch((error) => {
        switch (error.service) {
          case 'site':
            toastr.error(
              intl.get('search.searchFiltersService.siteServiceError')
            )
            break
          case 'settings':
            toastr.error(
              intl.get('search.searchFiltersService.settingsServiceError')
            )
            break
          default:
            toastr.error(intl.get('search.searchFiltersService.generalError'))
            break
        }
      })
  }

  this.setSearchTypeIndex = (event) => {
    const newIndex = sanitizeStoredSearchType(event.target.dataset.index)
    if (newIndex === $scope.searchTypeIndex) return
    $scope.searchTypeIndex = newIndex
    $scope.searchBarPlaceholder = determineSearchBarPlaceholder(
      $scope.searchTypeIndex
    )
    window.localStorage.setItem('searchTypeIndex', newIndex)
    $scope.runSearch()
  }

  this.browseAllTemplates = () => {
    renderSelectTemplateModal({
      visible: true,
      onSelect: (data) => {
        // handle selected data
      },
    })
  }

  const renderSelectTemplateModal = ({ visible, onSelect }) => {
    const close = () => {
      renderSelectTemplateModal({ visible: false, onSelect })
      // window.location.reload()
      this.shouldRerender = true
      link($scope, null, null, this)
    }
    ReactDOM.render(
      <SelectTemplateModal
        visible={visible}
        onClose={close}
        onSelect={(data) => {
          onSelect(data)
          close()
        }}
      />,
      reactRenderContainer
    )
  }

  const destroySnackbarComponent = () => {
    window.localStorage.removeItem(DELETED_FROM_NEW_EDITOR)
    window.localStorage.removeItem(STORY_DELETED_NAME)
    ReactDOM.unmountComponentAtNode(this.snackbarWrapper)
  }

  const renderSnackbar = async () => {
    const storyDeletedFlag = window.localStorage.getItem(
      DELETED_FROM_NEW_EDITOR
    )
    const storyName = window.localStorage.getItem(STORY_DELETED_NAME)
    const editorV2Enabled = $rootScope.globalSettings?.openBeta?.enabled

    if (editorV2Enabled && storyDeletedFlag && storyName) {
      ReactDOM.render(
        <Snackbar
          status="Success"
          message={this.intl.formatMessage(
            {
              id: 'story.snackbar.deleted',
            },
            {
              storyName,
            }
          )}
          timeout={DEFAULT_SNACKBAR_TIMEOUT}
          onTimeout={() => {
            destroySnackbarComponent()
          }}
        />,
        this.snackbarWrapper
      )
    }
  }

  this.$postLink = () => {
    $timeout(() => {
      // Do something with the DOM now that it has had it's bindings applied,
      // otherwise getElementById will return null.
      // https://stackoverflow.com/a/37306971
      this.createStoryButtonWrapper = document.getElementById(
        'btnCreateStoryWrapper'
      )
      reactRenderContainer = document.getElementById('template-modal')
      this.snackbarWrapper = document.getElementById('react-app--snackbar')

      renderSnackbar()
    })
  }

  $scope.$on('$destroy', () => {
    ReactDOM.unmountComponentAtNode(reactRenderContainer)
    ReactDOM.unmountComponentAtNode(this.createStoryButtonWrapper)
    ReactDOM.unmountComponentAtNode(this.snackbarWrapper)
  })

  if ($scope.isIframe) {
    angular.element('[nav-header]').hide()
  }

  function debounceFn(callback) {
    if (timer) {
      $timeout.cancel(timer)
    }
    timer = $timeout(callback, 400)
  }

  async function executeSearch() {
    try {
      toastr.clear()
      $scope.searchStatus = 'loading'
      timer = null

      const { results, error, response } = await searchService.fetchNewSearch(
        $scope.queryParams,
        $scope.filterConfig.sortFilters.value,
        $scope.filterConfig.websites.value,
        $scope.searchTypeIndex
      )

      if (error) {
        if (response?.data?.errorKey) {
          throw new Error(response.data.errorKey)
        }
        throw new Error('Stories Search Fetch error')
      }

      searchSuccess(results)
    } catch (error) {
      searchFailure(error.message)
    }
  }

  async function executeSearchById() {
    try {
      toastr.clear()
      $scope.searchStatus = 'loading'
      timer = null
      const storyId = $scope.filterConfig.searchBar.value
      const searchReq = {
        method: 'GET',
        url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/story/${storyId}/revision/draft`,
        timeout: 100000,
      }
      const variantsReq = {
        method: 'GET',
        url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/cc/${storyId}/variants`,
        timeout: 100000,
      }

      let variantsResponse = {}
      let searchResponse = {}
      const featureFlag = await evidentlyService.instance()
      if (featureFlag[EVIDENTLY_FLAG.CONDITIONAL_CONTENT]) {
        ;[variantsResponse, searchResponse] = await Promise.all([
          $http(variantsReq),
          $http(searchReq),
        ])
      } else {
        searchResponse = await $http(searchReq)
      }

      const resultStory = {
        ...searchResponse.data.revision.ans,
        _id: storyId,
        variations: variantsResponse.data,
      }

      // put the story in the result list
      setResult({ total: 1, content_elements: [resultStory] }, 'complete')
      if (isStatefulEnabled) {
        initiateLockStatusSubscription({
          content_elements: [resultStory],
        })
      } else {
        updateStoryLocks([resultStory._id])
      }
    } catch (error) {
      // if it is a 404, then id is not valid so do not show error message
      let status = 'error'
      if (error.status === 404) {
        status = 'complete'
      } else if (
        error.status === 403 &&
        error.data?.error?.errorKey === 'noAccessPerm'
      ) {
        status = 'noAccessPerm'
      } else if (
        error.status === 403 &&
        error.data?.error?.errorKey === 'authorNotFound'
      ) {
        status = 'authorNotFound'
      }
      setResult({ total: 0, content_elements: [] }, status)
    }
  }

  function setResult(hits, status) {
    $scope.searchResults = hits
    $scope.searchStatus = status
    storeService.set('stories', hits)
    if (!isStatefulEnabled) {
      restartInterval()
    }
    $scope.updatePublishingStatus()
  }

  function getFilterText(aPath) {
    const param =
      $scope.queryParams &&
      $scope.queryParams.find((t) => (t.path || '') === aPath)
    return param === undefined || param.value === undefined ? '' : param.value
  }

  function getStoryIdSearch() {
    const fullText = $scope.filterConfig.searchBar.value
    if (fullText) {
      const id = fullText.match(/^[\dA-Z]{26}$/i) ? fullText : null
      if (id) {
        return id
      }
    }
    return false
  }

  async function initializeLockIcons(searchResultsIds) {
    const { locks } = await getLocks({
      documentIds: searchResultsIds,
      attribute: 'DOCUMENT',
      dropTracker: false,
    })

    if (!locks.length) return

    const lockedStoryIds = locks.map((lock) => lock.entity_id)

    $scope.searchResults.content_elements.forEach((story) => {
      story.lock = lockedStoryIds.includes(story._id)
    })
  }

  function initiateLockStatusSubscription(data) {
    const documentIds = data.content_elements.map((story) => story._id)

    if (!documentIds.length) return

    const subscriptionConfigs = {
      query: LOCK_STATUS_CHANGED_SUBSCRIPTION,
      variables: {
        documentIds,
      },
    }

    const observable = gqlClient.subscribe(subscriptionConfigs)

    $scope.$on('$destroy', () => gqlClient.unsubscribe(subscriptionConfigs))

    const subscription = observable.subscribe({
      next: (result) => {
        const resultsWithGQLLock = data.content_elements.map((story) => {
          if (story._id === result.data.lockStatusChanged.documentId) {
            return { ...story, lock: result.data.lockStatusChanged.locked }
          }
          return story
        })
        setResult(
          { ...data, content_elements: resultsWithGQLLock },
          searchService.getStatus()
        )
      },
      error: (error) => {
        subscription.unsubscribe()
      },
      complete: () => {
        subscription.unsubscribe()
      },
    })

    initializeLockIcons(documentIds)
  }

  function searchSuccess(data) {
    const { count } = data
    // See if user entered in an id or canonical url
    if (count) {
      setResult(data, searchService.getStatus())

      if (isStatefulEnabled) {
        initiateLockStatusSubscription(data)
      }
    } else {
      // find canonical url, replace fwd slash
      const fullText = getFilterText('searchBar')
      const website = getFilterText('website')

      if (fullText.length && fullText.indexOf('/') > -1 && website) {
        const canUrl = fullText.replace(/\//g, '_')
        $http({
          method: 'GET',
          url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/stories/${website}/${canUrl}`,
          timeout: 10000,
        })
          .then((response) => {
            setResult(
              { total: 1, content_elements: [response.data] },
              'complete'
            )
            if (isStatefulEnabled) {
              initiateLockStatusSubscription({
                content_elements: [response.data],
              })
            }
          })
          .catch((error) => {
            setResult(
              { total: 0, content_elements: [] },
              error.status === 404 ? 'complete' : 'error'
            )
          })
      } else {
        setResult({ total: 0, content_elements: [] }, 'complete')
      }
    }
  }

  function searchFailure(message) {
    if (message === 'authorNotFound') {
      $scope.searchStatus = 'authorNotFound'
    } else {
      $scope.searchStatus = searchService.getStatus()
    }
  }

  function updateLocks() {
    /* If we do not have the current list of ids visible, find them from the list */
    if (!angular.isDefined(currentIds)) {
      currentIds =
        $scope.searchResults &&
        $scope.searchResults.hits &&
        $scope.searchResults.hits.map((hit) => hit._id)
    }

    /* Make sure we have locks to look for */
    if (currentIds && currentIds.length) {
      /* Fetch the lock status for the ids we have loaded */
      padlockService.getLocksForIds(currentIds).then((locks) => {
        /* Get the locks into a format we can look up stuff with quickly */
        const currentLocks = locks.data.reduce((o, lock) => {
          o[lock.item_id] = lock
          return o
        }, {})
        /* Replace the locks with the new results from the server */
        $scope.searchResults.hits.forEach((story) => {
          story.lock = currentLocks[story._id]
        })
      })
    } else {
      /* If there is nothing to find, than no need to loop */
      killInterval()
    }
  }

  function updateStoryLocks(storyIds) {
    padlockService.getLocksForIds(storyIds).then((locks) => {
      /* Get the locks into a format we can look up stuff with quickly */
      const currentLocks = locks.data.reduce((o, lock) => {
        o[lock.item_id] = lock
        return o
      }, {})
      /* Replace the locks with the new results from the server */
      $scope.searchResults.content_elements.forEach((story) => {
        story.lock = currentLocks[story._id]
      })
    })
  }

  function restartInterval() {
    killInterval()
    interval = $interval(updateLocks, 20000)
  }

  function killInterval() {
    if (angular.isDefined(interval)) {
      $interval.cancel(interval)
      interval = undefined
      currentIds = undefined
    }
  }

  $scope.$on('$destroy', killInterval)

  $scope.runSearch = function () {
    // If search index is 1, bypass filters and Content API and run the ID search
    if ($scope.searchTypeIndex === SEARCH_TYPE.ID) {
      const isId = getStoryIdSearch()
      const storyId = $scope.filterConfig.searchBar.value
      $location.search(
        `${SEARCH_TYPE_PARAM}=${$scope.searchTypeIndex}&id=${storyId}`
      )
      // make sure it is a valid story id
      if (isId) {
        debounceFn(executeSearchById)
      } else {
        setResult({ total: 0, content_elements: [] }, 'complete')
      }
    } else {
      const leftFilters = $scope.filterConfig.leftFilters.reduce(
        (filters, item) => {
          const value = item.setSearch()
          return !value ? filters : [...filters, { value, path: item.search }]
        },
        []
      )

      $scope.queryParams = [
        ...leftFilters,
        { value: $scope.filterConfig.websites.value, path: 'website' },
        { value: $scope.filterConfig.sortFilters.value, path: 'sortFilters' },
      ]

      if (get($scope, 'filterConfig.searchBar.value')) {
        $scope.queryParams.push({
          value: $scope.filterConfig.searchBar.value,
          path: 'searchBar',
        })
      }

      // we aren't doing sticky search dates or searchBar for now
      const localstorage = $scope.queryParams.filter(
        (i) =>
          ![
            'created_date',
            'publish_date',
            'last_updated_date',
            'searchBar',
          ].includes(i.path)
      )
      window.localStorage.setItem(
        'arc.searchFilterSettings',
        JSON.stringify(localstorage)
      )
      debounceFn(executeSearch)
    }
  }

  $scope.resetFilters = () => {
    window.localStorage.removeItem('arc.searchFilterSettings')
    $scope.filterConfig.searchBar.value = ''
    $scope.filterConfig.websites.value =
      $scope.filterConfig.websites.defaultValue
    $scope.filterConfig.sections.value = ''
    for (const i of Object.keys($scope.filterConfig.leftFilters)) {
      if ($scope.filterConfig.leftFilters[i].search !== 'type') {
        $scope.filterConfig.leftFilters[i].inputs.forEach((input) => {
          const { type } = input
          switch (type) {
            case 'radio':
              break
            case 'checkbox':
              input.checked = true
              break
            case 'toggle':
              input.value = input.default || false
              break
            default:
              input.value = input.default || ''
              break
          }
        })
      }
    }
    $scope.runSearch()
  }

  $scope.loadNext = function () {
    toastr.info(intl.get('search.loadNext'))
    const fetch = searchService.fetchNextPage()
    if (!fetch) return
    fetch.then(
      (response) => {
        toastr.clear()
        if (
          !$scope.searchResults ||
          !Array.isArray($scope.searchResults.content_elements)
        ) {
          setResult(response, searchService.getStatus())
        } else {
          $scope.searchResults.content_elements = $scope.searchResults.content_elements.concat(
            response.results.content_elements
          )
          setResult($scope.searchResults, searchService.getStatus())
        }
      },
      () => {
        $scope.searchStatus = searchService.getStatus()
      }
    )
  }

  $scope.onAutocomplete = ({ model }) => {
    $scope.filterConfig.leftFilters = $scope.filterConfig.leftFilters.map(
      (obj) => {
        if (obj.label === 'Author') {
          return { ...obj, value: model.name }
        } else {
          return obj
        }
      }
    )
    $scope.runSearch()
  }

  $scope.updateStories = (getPartialOrMutate) => {
    $scope.searchResults.content_elements = $scope.searchResults.content_elements.map(
      (story) => {
        Object.assign(story, getPartialOrMutate(story))
        return story
      }
    )
  }
  $scope.updatePublishingStatus = () => {
    const onlyPublished = getFilterText('revision.published') === 'true'
    $scope.updateStories((story) => ({
      syntheticPublishingStatus: onlyPublished
        ? true
        : isBoolean(story.syntheticPublishingStatus)
        ? story.syntheticPublishingStatus
        : null,
      publish_date: onlyPublished
        ? story.publish_date
        : isBoolean(story.syntheticPublishingStatus)
        ? story.publish_date
        : null,
    }))
    // Do not check for empty results or if only published has been requested
    if (onlyPublished || $scope.searchResults.content_elements.length === 0) {
      return
    }

    const ids = $scope.searchResults.content_elements
      .filter((story) => !isBoolean(story.syntheticPublishingStatus))
      .map((story) => story._id)
    if (!ids || ids.length === 0) {
      return
    }
    const currentWebsite = $scope.filterConfig.websites.value
    fetch(
      `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/bulksummary?id=${ids.join(
        '&id='
      )}&website=${currentWebsite}`
    )
      .then((response) => response.json())
      .then((response) => {
        $scope.updateStories((story) => {
          const summary = response.data[story._id]
          if (summary) {
            return {
              syntheticPublishingStatus: true,
              publish_date: summary.publish_date,
            }
          } else if (!isBoolean(story.syntheticPublishingStatus)) {
            return {
              syntheticPublishingStatus: false,
              publish_date: null,
            }
          }
        })
      })
      .catch(() => {
        toastr.error(intl.get('search.searchFiltersService.bulkError'))
        $scope.updateStories(() => ({
          syntheticPublishingStatus: intl.get('search.unknownPublishingStatus'),
          publish_date: null,
        }))
      })
      .finally(() => {
        $scope.$applyAsync()
      })
  }

  $scope.searchPlaceholderText = () => {
    return $scope.searchTypeIndex === SEARCH_TYPE.TERM
      ? intl.get('search.template.termsPlaceholder')
      : intl.get('search.template.idPlaceholder')
  }

  this.fetchSettings = settingsService.fetchSettings
  this.companySettings = $scope.companySettings
  this.toastrService = toastr

  if (!$scope.isIframe) {
    sessionStorage.removeItem('set_tab')
    padlockService.cleanUp()
  }
}
